import React, {useEffect, useState} from 'react';
import {Route, Routes} from "react-router-dom";
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Main from "../Pages/Main/Main";
import Catalog from "../Pages/Catalog/Catalog";
import ElevateAppBar from "./AppBar/ElevateAppBar";
import NotFound404 from "./NotFound404/NotFound404";
import Tets from "./Test/tets";
import 'react-toastify/dist/ReactToastify.css';
import Favorites from "./Favorites/Favorites";
import ProductCard from "./ProductCard/ProductCard";
import FullCart from "../Pages/FullCart/FullCart";
import ProductAdd from "./ProductAdd/ProductAdd";
import DInfo from "./DInfo/DInfo";
import OurContacts from "./OurContacts/OurContacts";
import Oferta from "./Oferta/Oferta";
import Stocks from "./Stocks/stocks";
import NewStocks from "./StocksNew/newStocks";
import NewCatalog from "./NewCatalog/NewCatalog";
import DigitalProductCard from "./DigitalProductCard/DigitalProductCard";
import ShortAbout from "./ShortAbout/ShortAbout";
import ZakazBuff from "./ZakazBuff/ZakazBuff";
import NewColors from "./NewColors/NewColors";
import ZakazHoba from "./ZakazHoba/ZakazHoba";

const Cont_style={
    'display':'block',
    'flex-direction': "row",
    'flex-wrap': "wrap",
    'padding-left': "0px",
    'color':"#00110011"
}


const nrtheme = createTheme({
    palette: {
        primary: {
            main: '#382b2f',
        },
        secondary: {
            main: '#d8d9d9',
        },
        text: {
            primary: '#d8d9d9',
            secondary: '#d8d9d9',
            hint: '#d8d9d9',
            disabled: '#d8d9d9'
        },
        type: 'dark',
    },
});


const AppRoute = () => {
    var colfav=JSON.parse(localStorage.getItem('favorites'))
    var colcart=JSON.parse(localStorage.getItem('cart'))
    var delivery=JSON.parse(localStorage.getItem('delivery'))
    var contacts=JSON.parse(localStorage.getItem('contacts'))
    var payMethod=JSON.parse(localStorage.getItem('payMethod'))

    if (payMethod==null)
    {
        payMethod={
            Type: '',
        }
        localStorage.setItem('payMethod',JSON.stringify(payMethod));
    }
    if (contacts==null)
    {
        contacts={
            fname: '',
            phone: '',
            email: '',
            tlg: false,
        }
        localStorage.setItem('contacts',JSON.stringify(contacts));
    }
    if (delivery==null)
    {
        delivery= {
            Type:"Самовывоз",
            BoxBerryPVZ:{adress:"не выбран",price:"0"},
            BoxBerryPVZText:"",
            Adress:"г.Москва, ул.Богородский вал 6к2, (м.Преображенская площадь)",
            ViewText:"",
            Zip:"",
            Price:0,
            Phone:"+7(916)386-50-50"
        }
        localStorage.setItem('delivery',JSON.stringify(delivery));

    }

    if (colfav==null)
    {
        colfav=[]
    }

    if (colcart==null)
    {
        colcart=[]
    }
    const [lenfavorites, setLenFavorites]= useState(colfav.length)
    const [lenCart, setLenCart]= useState(colcart.length)
    const [isMobile, setIsMobile] = useState(false)
    const [refresh, setrefresh] = useState(false)
    // var favor= ;
    const callup = (len) => {
        var xx=JSON.parse(localStorage.getItem('favorites')).length
        var yy=JSON.parse(localStorage.getItem('cart')).length
        setLenFavorites(xx)
        setLenCart(yy)
    }
    const handleResize = () => {
        if (window.innerWidth < 600) {
            setIsMobile(true)
        } else
        if (window.innerWidth < 900)
        {
            setIsMobile(false)
        } else
        {
            setIsMobile(false)
        }
    }


    useEffect(() => {
        window.addEventListener("resize", handleResize)
        handleResize()
    })
    return (
        <ThemeProvider theme={nrtheme}>
                    <ElevateAppBar lenCart={lenCart} lenfavorites={lenfavorites} isMobile={isMobile}/>
                    <Routes>
                        {/*<Route path="/" element={<Main callbackX={callup} style={Cont_style}/>}/>*/}


                        <Route path="/" element={<><ShortAbout/> <NewCatalog/></>}/>
                        <Route path="/zakazBuff" element={<ZakazBuff/>}/>
                        <Route path="/zakazHoba" element={<ZakazHoba/>}/>
                        <Route path="/catalog" element={<NewCatalog/>}/>

                        <Route path="/newcatalog" element={<NewCatalog/>}/>
                            {/*<Route path="/category"element={<Products callbackX={callup}/>}>*/}
                        {/*    <Route path=":category_id" element={<Products/>} />*/}
                        {/*</Route>*/}

                        <Route path="/category"element={<Tets callbackX={callup}/>}>
                            <Route path=":category_id" element={<Tets/>} />
                        </Route>

                        <Route path="/products"element={<ProductCard callbackX={callup}/>}>
                            <Route path=":product_id" element={<ProductCard/>} />
                        </Route>

                        <Route path="/Digital"element={<DigitalProductCard callbackX={callup}/>}>
                            <Route path=":product_id" element={<DigitalProductCard/>} />
                            {/*ssskkkkk*/}
                        </Route>

                        <Route path="/contacts" element={<OurContacts/>}></Route>

                        <Route path="/oferta" element={<Oferta/>}></Route>
                        {/*<Route path="/enot_30273e96.html" element={"enot-domain-conform-text"}></Route>*/}

                        <Route path="/info" element={
                            <DInfo></DInfo>
                        }></Route>
                        <Route path="/stocksold" element={
                           <Stocks/>
                        }></Route>
                        <Route path="/stocks" element={
                            <NewStocks/>
                        }></Route>
                        <Route path="/colors" element={
                            <NewColors/>
                        }></Route>
                        <Route path="/cart" element={<FullCart callbackX={callup}/>}>
                    </Route>

                        <Route path="/favorites" element={<Favorites callbackX={callup}/>}></Route>

                        {/*<Route path="/add" element={<ProductAdd callbackX={callup}/>}></Route>*/}
                        <Route path="*" element={<NotFound404/>}/>
                    </Routes>


        </ThemeProvider>
    );
};

export default AppRoute;